import {
  RESET_STATUS_INVOICE,
  SUCCESS_SHOW_STATUS_INOVOICE_BARANG,
} from "../../constants/expediting/expeditingTypes";

const initState = {};

const invoiceStatusReducer = (state = initState, action) => {
  switch (action.type) {
    case SUCCESS_SHOW_STATUS_INOVOICE_BARANG:
      return { ...state, [action.data.uuid_expediting]: action.data };
    case RESET_STATUS_INVOICE:
      return {};
    default:
      return state;
  }
};

export default invoiceStatusReducer;
